// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner__banner__fec5H"};